import BigNumber from 'bignumber.js';

export default function isShareEmpty(share) {
  return new BigNumber(share.total).isEqualTo(0);
}
